import { HaircutBand } from 'api'
import { isNil } from 'lodash'

export const populateValuesByBand = (
  values: {
    [index: string]: number
  } | null,
  newValue: string,
  id: string,
  haircutBands: HaircutBand[]
) => {
  let valuesByBand = {
    ...values
  }
  if (id === '1') {
    const restOfIds = Object.values(haircutBands)
      .filter(item => item.id !== '1')
      .map(item => item.id)

    restOfIds.forEach(id => {
      if (isNil(valuesByBand[id])) {
        valuesByBand[id] = Number(newValue)
      }
    })
  }
  return valuesByBand
}
